export default {

  inputbox:         'INPUTBOX',
  autocomplete:     'AUTOCOMPLETE',
  autocompleteSpec: 'AUTOCOMPLETE?',
  multiselect:      'MULTISELECT',
  dropDown:         'DROPDOWN',
  datepicker:       'DATEPICKER',
  date:             'DATE',
  bookMark:         'ENUBOOKMARK',
  document:         'DOCUMENT',
  signature:        'SIGNATURE',
  password:         'PASSWORD',
  checkbox:         'CHECKBOX',
  toggle:           'TOGGLE',

  enuEntForm:    'ENUENTFORM',
  enuFormMenu:   'ENUFORMMENU',
  enuFormAction: 'ENUBUTTON',
  icon:          'ICON',

  asArray: [
    'INPUTBOX',
    'AUTOCOMPLETE',
    'AUTOCOMPLETE?',
    'MULTISELECT',
    'DROPDOWN',
    'DATEPICKER',
    'DATE',
    'ENUBOOKMARK',
    'DOCUMENT',
    'ENUFORMMENU',
    'SIGNATURE',
    'PASSWORD',
    'CHECKBOX',
    'TOGGLE'
  ],

  dataType: {
    decimal99:     'DECIMAL99',
    decimal0:      'DECIMAL0',
    decimal1:      'DECIMAL1',
    decimal2:      'DECIMAL2',
    decimal3:      'DECIMAL3',
    decimal4:      'DECIMAL4',
    datetime:      'DATETIME',
    date:          'DATE',
    datetimeinput: 'DATETIMEINPUT',
    money:         'MONEY',
    inputBox:      'INPUTBOX',
    text:          'TEXT',
    time:          'TIME',
    email:         'EMAIL'
  }

}
